import { Routes, Route, useLocation } from 'react-router';
import { AnimatePresence } from 'motion/react';
import { PageLayout } from '@components/layout/PageLayout';
import { ROUTES } from '@constants/routes';
import Home from '@pages/Home';
import About from '@pages/About';
import Events from '@pages/Events';
import EventDetail from '@pages/EventDetail';
import NotFound from '@pages/NotFound';

/**
 * Raiz da aplicação.
 * PageLayout (Header + Footer) envolve todas as rotas.
 * AnimatePresence via location.key — pronto para page transitions na Etapa 7.
 */
export default function App() {
  const location = useLocation();

  return (
    <PageLayout heroMode>
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={location.pathname}>
          <Route path={ROUTES.home} element={<Home />} />
          <Route path={ROUTES.about} element={<About />} />
          <Route path={ROUTES.events} element={<Events />} />
          <Route path={ROUTES.eventDetail} element={<EventDetail />} />
          <Route path={ROUTES.notFound} element={<NotFound />} />
        </Routes>
      </AnimatePresence>
    </PageLayout>
  );
}
